<template>
  <div class="block h-14"></div>
</template>

<script>
export default {
  name: 'EmptySpace'
}
</script>

<style scoped>

</style>
